var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { sendLog } from "./utils/sendLog";
const loadedFonts = {};
const loadFont = (name, filePath) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const fontToLoad = new FontFace(name, `url(${filePath}) format("woff")`);
        loadedFonts[name] = fontToLoad;
        yield fontToLoad.load().then(() => {
            document.fonts.add(fontToLoad);
        }).catch(() => {
            const message = `Failed to load font ${name} from ${filePath}`;
            console.warn(message);
            sendLog(message);
        });
    }
    catch (error) {
        if (error instanceof Error) {
            sendLog("Error loading fonts: " + error.message);
        }
    }
});
const getFontPath = (config) => {
    if (config.fontPath !== undefined) {
        return config.fontPath;
    }
    if (config.assetPath !== undefined) {
        return config.assetPath + "assets/fonts/";
    }
    return "../../nexus-assets/assets/fonts/";
};
export const loadFonts = (dependencies, layerConfig, priorityRange) => __awaiter(void 0, void 0, void 0, function* () {
    if (FontFace === undefined) {
        return;
    }
    const { fonts } = dependencies;
    const path = getFontPath(layerConfig);
    const fontLoads = new Set();
    fonts.forEach((loadPriority, fontName) => {
        if (loadPriority < priorityRange[0] || loadPriority > priorityRange[1] || loadedFonts[fontName]) {
            return;
        }
        fontLoads.add(loadFont(fontName, `${path}${fontName}.woff`));
    });
    layerConfig.modules.forEach((module) => {
        if (module.fonts === undefined || module.fonts === "") {
            return;
        }
        if (module.priority < priorityRange[0] || module.priority > priorityRange[1]) {
            return;
        }
        module.fonts.split(",").forEach((fontName) => {
            if (!loadedFonts[fontName]) {
                fontLoads.add(loadFont(fontName, `${path}${fontName}.woff`));
            }
        });
    });
    yield Promise.all(fontLoads);
});
